export class OrganizationListItem
{
    Id!: number;
    Name!: string;
    Group?: string;
    TenantId!: string;

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Handle any custom mappings here
            if (this.Group == null) this.Group = undefined;

        }
    }
}
